(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdp-animated-steps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pdp-animated-steps')) {
    customElements.define(
      'pdp-animated-steps',
      class PdpAnimatedSteps extends HTMLElement {
        connectedCallback() {
          this.hasLoop = this.dataset.loop === 'true';
          this.onIntersect = this.onIntersect.bind(this);

          if (!('IntersectionObserver' in window)) {
            this.classList.add('is-in-view');
            if (!this.hasLoop) this.queueCompleteState();
            return;
          }

          this.observer = new IntersectionObserver(this.onIntersect, {
            threshold: 0.32,
            rootMargin: '0px 0px -12% 0px',
          });
          this.observer.observe(this);
        }

        disconnectedCallback() {
          if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
          }

          if (this.completeTimer) {
            window.clearTimeout(this.completeTimer);
            this.completeTimer = null;
          }
        }

        onIntersect(entries) {
          const entry = entries[0];
          if (!entry?.isIntersecting) return;

          this.classList.add('is-in-view');

          if (this.hasLoop) return;

          this.queueCompleteState();
          this.observer?.unobserve(this);
        }

        queueCompleteState() {
          const styles = getComputedStyle(this);
          const duration = Number.parseFloat(styles.getPropertyValue('--pdp-animated-steps-duration')) || 5;
          const stepDelay = Number.parseFloat(styles.getPropertyValue('--pdp-animated-steps-step-delay')) || duration / 3;
          const stepsCount = Math.max(this.querySelectorAll('.pdp-animated-steps__item').length, 1);
          const totalDuration = duration + stepDelay * Math.max(stepsCount - 1, 0);

          this.completeTimer = window.setTimeout(() => {
            this.classList.add('is-complete');
            this.completeTimer = null;
          }, totalDuration * 1000);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-shop-growth-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tmf-growth-product-carousel')) {
    class TmfGrowthProductCarousel extends HTMLElement {
      #controller = null;
      #index = 0;
      #intersectionObserver = null;
      #isIntersecting = true;
      #slides = [];
      #timer = null;

      connectedCallback() {
        this.classList.remove('is-running');
        this.#isIntersecting = false;
        this.#stop();
        this.#controller?.abort();
        this.#intersectionObserver?.disconnect();

        this.#controller = new AbortController();
        this.#slides = Array.from(this.querySelectorAll('[data-growth-product-slide]'));
        this.#index = Math.max(
          0,
          this.#slides.findIndex((slide) => slide.dataset.state === 'active')
        );

        this.addEventListener('mouseenter', () => this.#stop(), {
          signal: this.#controller.signal,
        });
        this.addEventListener('mouseleave', () => this.#start(), {
          signal: this.#controller.signal,
        });
        this.addEventListener('focusin', () => this.#stop(), {
          signal: this.#controller.signal,
        });
        this.addEventListener(
          'focusout',
          (event) => {
            if (!this.contains(event.relatedTarget)) this.#start();
          },
          { signal: this.#controller.signal }
        );
        document.addEventListener(
          'visibilitychange',
          () => {
            if (document.hidden) this.#stop();
            else this.#start();
          },
          { signal: this.#controller.signal }
        );

        if ('IntersectionObserver' in window) {
          this.#isIntersecting = false;
          this.#intersectionObserver = new IntersectionObserver(
            (entries) => {
              this.#isIntersecting = entries[0]?.isIntersecting ?? false;
              if (this.#isIntersecting) this.#start();
              else this.#stop();
            },
            { threshold: 0.25 }
          );
          this.#intersectionObserver.observe(this);
        }

        this.#render();
        this.#start();
      }

      disconnectedCallback() {
        this.#stop();
        this.#controller?.abort();
        this.#intersectionObserver?.disconnect();
      }

      #render() {
        const slideCount = this.#slides.length;
        if (slideCount === 0) return;

        for (const [slideIndex, slide] of this.#slides.entries()) {
          const relativeIndex = (slideIndex - this.#index + slideCount) % slideCount;
          let state = 'hidden';

          if (relativeIndex === 0) state = 'active';
          else if (relativeIndex === 1) state = 'next';
          else if (relativeIndex === 2) state = 'next-far';
          else if (relativeIndex === slideCount - 2) state = 'previous-far';
          else if (relativeIndex === slideCount - 1) state = 'previous';

          slide.dataset.state = state;
          slide.setAttribute('aria-hidden', String(state !== 'active'));
          slide.inert = state !== 'active';
        }

        this.dataset.activeIndex = String(this.#index + 1);
      }

      #start() {
        this.#stop();
        if (this.#slides.length < 2) return;
        if (!this.#isIntersecting || document.hidden) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const interval = Number.parseInt(this.dataset.interval, 10) || 1750;
        this.#timer = window.setInterval(() => {
          this.#index = (this.#index + 1) % this.#slides.length;
          this.#render();
        }, interval);
      }

      #stop() {
        if (this.#timer === null) return;
        window.clearInterval(this.#timer);
        this.#timer = null;
      }
    }

    customElements.define('tmf-growth-product-carousel', TmfGrowthProductCarousel);
  }

  if (!customElements.get('tmf-growth-approval-sequence')) {
    class TmfGrowthApprovalSequence extends HTMLElement {
      #activeIndex = 3;
      #controller = null;
      #intersectionObserver = null;
      #motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      #motionHandler = () => this.#syncMotion();
      #isIntersecting = false;
      #steps = [];
      #timer = null;

      connectedCallback() {
        this.classList.remove('is-running', 'is-complete');
        this.#isIntersecting = false;
        this.#stop();
        this.#controller?.abort();
        this.#intersectionObserver?.disconnect();
        this.#controller = new AbortController();
        this.#steps = Array.from(this.querySelectorAll('[data-approval-step]'));
        if (this.#motionQuery.matches) this.#renderStaticState();
        else this.#render(0);
        this.#motionQuery.addEventListener?.('change', this.#motionHandler);
        document.addEventListener('visibilitychange', this.#motionHandler, {
          signal: this.#controller.signal,
        });

        if ('IntersectionObserver' in window) {
          this.#intersectionObserver = new IntersectionObserver(
            (entries) => {
              this.#isIntersecting = (entries[0]?.intersectionRatio ?? 0) >= 0.3;
              this.#syncMotion();
            },
            { threshold: 0.3 }
          );
          this.#intersectionObserver.observe(this);
        } else {
          this.#isIntersecting = true;
          this.#syncMotion();
        }
      }

      disconnectedCallback() {
        this.#stop();
        this.#controller?.abort();
        this.#intersectionObserver?.disconnect();
        this.#motionQuery.removeEventListener?.('change', this.#motionHandler);
      }

      #syncMotion() {
        const shouldRun = this.#isIntersecting && !this.#motionQuery.matches && !document.hidden;

        if (shouldRun) {
          this.#start();
          return;
        }

        this.classList.remove('is-running', 'is-complete');
        this.#stop();
        if (this.#motionQuery.matches) this.#renderStaticState();
        else this.#render(0);
      }

      #start() {
        if (
          this.classList.contains('is-running')
          || this.classList.contains('is-complete')
          || this.#steps.length === 0
        ) return;

        this.classList.add('is-running');
        this.#render(0);
        this.#scheduleNext(900);
      }

      #scheduleNext(delay) {
        this.#stop();
        this.#timer = window.setTimeout(() => {
          this.#timer = null;
          if (!this.classList.contains('is-running')) return;

          const lastIndex = this.#steps.length - 1;
          if (this.#activeIndex >= lastIndex) {
            this.classList.remove('is-running');
            this.classList.add('is-complete');
            return;
          }

          this.#render(this.#activeIndex + 1);
          if (this.#activeIndex >= lastIndex) {
            this.classList.remove('is-running');
            this.classList.add('is-complete');
            return;
          }

          this.#scheduleNext(900);
        }, delay);
      }

      #stop() {
        if (this.#timer === null) return;
        window.clearTimeout(this.#timer);
        this.#timer = null;
      }

      #renderStaticState() {
        this.#render(this.#steps.length - 1);
      }

      #render(index) {
        if (this.#steps.length === 0) return;

        this.#activeIndex = Math.max(0, Math.min(index, this.#steps.length - 1));
        this.dataset.activeStep = String(this.#activeIndex);

        this.#steps.forEach((step, stepIndex) => {
          step.classList.toggle('is-active', stepIndex <= this.#activeIndex);
          step.classList.toggle('is-current', stepIndex === this.#activeIndex);
          step.classList.toggle('is-connected', stepIndex < this.#activeIndex);
        });
      }
    }

    customElements.define('tmf-growth-approval-sequence', TmfGrowthApprovalSequence);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-shop-image-tiles"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var trigger = target.closest('[data-tmf-open-proposal-booking]');
    if (!trigger) return;

    var booking = document.querySelector('tmf-proposal-booking');
    if (booking && typeof booking.open === 'function') {
      event.preventDefault();
      booking.open();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topbar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    for (const selector of document.querySelectorAll('.topbar-localization[open]')) {
      if (selector.contains(event.target)) continue;

      selector.removeAttribute('open');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    for (const selector of document.querySelectorAll('.topbar-localization[open]')) {
      selector.removeAttribute('open');
      selector.querySelector('[data-disclosure-toggle]')?.focus();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
